import { tw } from "@careinfo/tailwind";
import loadable from "@loadable/component";
import { UseFormSetError } from "react-hook-form";
import { toast } from "react-toastify";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../hooks/usePostHook";
import CreateIcon from "../../icons/CreateIcon";
import { IPopup } from "../../types/interface";

const CreatePopupModalComponent = loadable(
  () => import("../../components/PopupModal/Create")
);

export default function CreatePopupModal() {
  const { mutateAsync: createPopupModal, isLoading: isCreatingPopupModal } =
    usePostHook({
      queryKey: ["create-page"],
      navigateURL: "/website-builder/popup-modal",
    });

  const handleCreate = async (
    data: IPopup,
    setError: UseFormSetError<IPopup>
  ) => {
    try {
      const url = APIS.POPUP;
      await createPopupModal({
        url,
        formData: {
          ...data,
        },
        setError,
      });
    } catch (e) {
      if (e instanceof Error) toast.error(e.message);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Popup Modal
        </span>
      </div>
      <CreatePopupModalComponent
        handleCreate={handleCreate}
        isCreatingPopupModal={isCreatingPopupModal}
      />
    </>
  );
}
